import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const UpdatePasswordScreen: React.FC = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { updateUserPassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
        setError("Le mot de passe doit contenir au moins 6 caractères.");
        return;
    }

    if (password !== confirmPassword) {
        setError("Les mots de passe ne correspondent pas.");
        return;
    }

    setIsLoading(true);

    try {
      await updateUserPassword(password);
      alert("Mot de passe mis à jour avec succès ! Vous êtes connecté.");
      // La redirection est gérée par le changement d'état dans AuthContext (isPasswordRecovery -> false)
    } catch (err: any) {
      setError(err.message || "Impossible de mettre à jour le mot de passe.");
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-lg">
        <h1 className="text-3xl font-bold text-center text-green-600 mb-2">Nouveau mot de passe</h1>
        <p className="text-center text-gray-500 mb-8">
            Sécurisez votre compte avec un nouveau mot de passe.
        </p>

        {error && (
            <div className="p-3 mb-6 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600">
                {error}
            </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="new-password" className="text-sm font-semibold text-gray-700">Nouveau mot de passe</label>
            <input
              id="new-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Minimum 6 caractères"
              required
              className="w-full p-3 mt-1 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 bg-white text-gray-900"
            />
          </div>

          <div>
            <label htmlFor="confirm-password" className="text-sm font-semibold text-gray-700">Confirmer le mot de passe</label>
            <input
              id="confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Répétez le mot de passe"
              required
              className="w-full p-3 mt-1 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 bg-white text-gray-900"
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-3 font-bold text-white bg-green-600 rounded-full hover:bg-green-700 transition-colors disabled:bg-green-300 shadow-md"
          >
            {isLoading ? 'Mise à jour...' : 'Confirmer'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdatePasswordScreen;